import { BaseConnector } from './basic';
import { Address } from '@ton/core';
const addressConvert = address => {
  const inst = Address.parse(address);
  return {
    raw: inst.toRawString(),
    bounceable: inst.toString({ bounceable: true }),
    unbounceable: inst.toString({ bounceable: false }),
  };
};
export class TONConnector extends BaseConnector {
  async connect(): Promise<any> {
    this.checkWindow();

    const { bitkeep } = window as any;
    if (!bitkeep?.ton) {
      throw new Error('BitKeep TON not installed');
    }

    const response = await bitkeep.ton.send('ton_connect');
    const address = addressConvert(response[0].address);
    this.address = {
      ...response[0],
      ...address,
    };
    return this.address;
  }
  async switchNetwork(): Promise<string> {
    return null;
  }
  async sendTransaction(transaction): Promise<string> {
    this.checkWindow();
    const { bitkeep } = window as any;
    if (!bitkeep?.ton) {
      throw new Error('BitKeep not installed');
    }
    const provider = bitkeep.ton;
    const signature = await provider.send('ton_sendTransaction', transaction);
    return signature;
  }
}
